<template>
  <div class="product-block">
    <div class="title">Эспумизан<sup>®</sup> <span class="green"> экстра</span> – возьми с собой!</div>
    <img src="http://ar.tns-counter.ru/V13a****ar_ru/ru/CP1251/tmsec=177193_650551-2706193/" alt="">
    <div>
    <div class="product-container">
      <div class="product-text">
        <ul>
          <li>Помогает при вздутии живота</li>
          <li>С приятным вкусом</li>
          <li> Удобно – возьми с собой</li>
        </ul>
        <a @click="gaLink" href="http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&bt=2&ad=650551&pid=2706193&bid=5745599&bn=5745599&rnd=2055460214" target="_blank" class="button">Возьми с собой!</a>
      </div>
      <a @click="gaLink"  class="product-image" href="http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&bt=2&ad=650551&pid=2706193&bid=5745599&bn=5745599&rnd=2055460214" target="_blank">
        <img src="../assets/img/product.png" alt="">
      </a>
    </div></div>
  </div>
</template>

<script>
export default {
  name: "Product",
  methods: {
    gaLink() {
      this.$ga.event("Ссылка", `Ссылка на продукте`, 1);
    }
  }
};
</script>

<style scoped lang="scss">
.product-block {
  margin: 100px auto;
  min-height: 400px;
  background: #f5f5f5 url("../assets/img/product-bg.jpg") no-repeat bottom
    center;
  display: flex;
  flex-direction: column;
}

.title {
  margin: 60px auto 0;
  &:before {
    display: block;
    position: absolute;
    content: "Симетикон";
    text-transform: uppercase;
    font-size: 10px;
    top: 3px;
    left: 22px;
  }
  font-weight: 700;
  display: block;
  position: relative;
  font-size: 35px;
  sup {
    font-size: 20px;
  }
  .green {
    color: #28a24a;
  }
}

.product-container {
  max-width: 640px;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  img {
    width: 100%;
  }
  .product-text {
    ul {
      list-style: none;
      margin: 0;
      padding: 0 0 0 20px;
      padding-right: 20px;
      li {
        padding-left: 1em;
        text-indent: -0.7em;
        line-height: 30px;
        position: relative;
        font-size: 18px;
        &::before {
          display: inline-block;
          position: absolute;
          left: -10px;
          content: "• ";
          color: #28a24a;
          font-weight: 700;
          font-size: 30px;
        }
      }
    }
  }
}

.button {
  background: #28a24a;
  text-decoration: none;
  color: white;
  padding: 10px 20px;
  display: inline-block;
  margin-top: 20px;
}
@media screen and (max-width: 768px) {
  .button {
    background: #28a24a;
    text-decoration: none;
    color: white;
    padding: 7px 10px;
    display: inline-block;
    margin-top: 20px;
    font-size: 14px;
  }
  .product-block {
    padding: 20px;
    background: #f5f5f5;
    background-image: url("../assets/img/product-bg-mobile.jpg");
    background-size: cover;
    background-position: bottom;
    margin: 50px auto;
    margin-left: -30px;
    margin-right: -30px;
  }

  .title {
    margin-top: 20px;
    font-size: 21px;
    &:before {
      font-size: 7px;
      top: 0;
      left: 13px;
    }
    sup {
      font-size: 12px;
    }
  }
  .product-container {
    flex-direction: column;
    justify-content: space-between;

    .product-text {
      margin-top: 10px;
      ul {
        li {
          padding-left: 5px;
          line-height: 20px;
          font-size: 13px;
        }
      }
    }
    .product-image {
      width: 60%;
      margin-top: -10px;
      padding-bottom: 18vmin;
      align-self: flex-end;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product.vue